import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'common/i18n/hooks';
import styles from './_header.module.styl';
import rowStyles from './_row.module.styl';
import { ExperimentPageSummaryMetricsCategoryChartHeader } from './_chart-header';
type ExperimentPageSummaryMetricsCategoryHeaderProps = {
  absMax: number;
  multiVariant?: boolean;
};
export function ExperimentPageSummaryMetricsCategoryHeader(_ref: ExperimentPageSummaryMetricsCategoryHeaderProps) {
  let {
    absMax,
    multiVariant
  }: ExperimentPageSummaryMetricsCategoryHeaderProps = _ref;
  const i18n = useTranslation();
  return <div className={clsx(rowStyles.row, styles.row)} data-sentry-component="ExperimentPageSummaryMetricsCategoryHeader" data-sentry-source-file="_header.tsx">
      <div className={clsx(multiVariant ? rowStyles.metricNameMultiVariant : rowStyles.metricNameSingleVariant, rowStyles.metricName, styles.editable)}>
        {i18n.t("experiments.main.metrics.category-metric")}
      </div>
      <div className={rowStyles.variantsColumn}>
        <div className={clsx(rowStyles.variant, {
        [rowStyles.multiVariant]: multiVariant
      })}>
          {multiVariant ? <div className={rowStyles.variantName}>{i18n.t("experiments.main.metrics.category-variant")}</div> : null}
          <div className={rowStyles.metricValue}>{i18n.t("experiments.main.metrics.category-lift")}</div>
          <div className={rowStyles.metricValue}>{i18n.t("experiments.main.metrics.category-control")}</div>
          <div className={rowStyles.metricValue}>{i18n.t("experiments.main.metrics.category-treatment")}</div>
          <div className={rowStyles.metricGraph}>
            <ExperimentPageSummaryMetricsCategoryChartHeader absMax={absMax} data-sentry-element="ExperimentPageSummaryMetricsCategoryChartHeader" data-sentry-source-file="_header.tsx" />
          </div>
        </div>
      </div>
    </div>;
}